/* @flow */

import { parse } from 'url';

import { loginRoute } from 'src/shared/app/base/route/setting/routeSettings';
import { getRoutePath } from 'src/shared/app/base/route/util/routeUtils';
import { logoutEndpoint } from 'src/shared/app/base/settings/endpointSettings';
import { tokenQueryParam } from 'src/shared/app/base/route/setting/querySettings';
import { liveChatsActions } from 'plugin/live-chat/action/liveChatAction';
import { isErrorReportingEnabled } from 'src/shared/app/base/selector/appEnvSelectors';
import {
  removeTokenFromCookie,
  saveTokenInCookie,
} from 'src/shared/app/base/util/tokenUtils';

import type { BraindateEvent } from '@braindate/domain/lib/event/type';
import { unregisterSentryUserFromBrowser } from 'src/shared/app/base/util/sentryUtils';

export function injectTokenInCookie(event: BraindateEvent): void {
  // @TODO - TEMP-AUTH
  const queryToken = getQueryToken(encodeURI(window.location.href));
  if (queryToken) {
    // @TODO - TEMP-AUTH Use env provider
    saveTokenInCookie(queryToken, !process.env.DEV_MODE, event);
  }
}

export function getQueryToken(url: string): void {
  const { query } = parse(url, true);
  const queryToken = (query: Object)[tokenQueryParam];
  return queryToken;
}

export function handleLogOut(): any {
  return (dispatch: any, getState, { post }: Object) => {
    const { kill } = liveChatsActions;
    dispatch(kill);

    removeTokenFromCookie();

    if (isErrorReportingEnabled(getState())) {
      unregisterSentryUserFromBrowser();
    }

    return post(logoutEndpoint()).then(() => {
      window.location = getRoutePath(loginRoute);
    });
  };
}
